import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

export interface SurveyQuestions {
  id: string;
  slug: string;
  title: string;
  icon: string;
  type: string;
  rating: string;
}

export interface Survey {
  id: string;
  slug: string;
  name: string;
  questions: Array<SurveyQuestions>;
  date: string;
  ip: string;
}

@Component({
  selector: 'fcp-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent implements OnInit {
  @Input() survey: Survey;
  @Output() public emitSurvey: EventEmitter<any> = new EventEmitter();

  public mini = true;
  public completed = false;
  public clickedId = 0;

  constructor() { }

  ngOnInit() { }

  ratingComponentClick(clickObj: any): void {
    const item = this.survey.questions.find(((i: any) => i.id === clickObj.itemId));
    if (!!item) {
      item['rating'] = '' + clickObj.rating;
      this.clickedId++;
    }
  }

  fillField(event) {
    this.survey.questions[this.clickedId]['rating'] = '' + event.target.value;
  }

  sendSurvey() {
    this.completed = true;
    this.emitSurvey.emit(this.survey);
  }
}
